module.exports = __webpack_public_path__ + "img/fr_task_panduan.b1caca6f.png";